import { useEffect } from 'react';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';

import { getMessage } from '@gef-ui/localization/messages';
import LinearProgressWithLabel from '@gef-ui/material/components/LinearProgressWithLabel';

import contactReleasing from 'features/views/campaignManagement/contactReleasing';

const message = (type, remaining) =>
	getMessage('campaignManagement:progressMessage', {
		progressType: getMessage(`campaignManagement:${type}ProgressType`),
		contactNumber: remaining,
	});

let timer;

export const Progress = () => {
	const dispatch = useDispatch();

	const progress = useSelector(contactReleasing.selectors.getProgress);

	// // progress is updated every 2s so i hope after 5s if remaining is 0 that process is done
	const checkProgress = () => {
		clearTimeout(timer);
		if (progress && progress.remaining === 0) {
			timer = setTimeout(() => {
				dispatch(contactReleasing.actions.setProgress(null));
			}, 5000);
		}
	};

	useEffect(() => {
		checkProgress();
	});

	if (!progress) return null;

	const progressCount = progress?.count || 0;
	const progressRemaining = progress?.remaining || 0;

	return (
		<>
			<Paper
				sx={{
					p: 3,
					borderRadius: 2,
					boxShadow:
						' 0px 3px 1px -2px rgba(141, 142, 143, 0.2), 0px 2px 2px 0px rgba(141, 142, 143, 0.14), 0px 1px 5px 0px rgba(141, 142, 143, 0.12)',
				}}
			>
				<Stack
					sx={{
						justifyContent: 'center',
					}}
				>
					<Typography variant="body2">{message(progress.type, progress.remaining)}</Typography>
					<LinearProgressWithLabel
						value={progressCount !== 0 ? ((progressCount - progressRemaining) / progressCount) * 100 : 0}
					/>
				</Stack>
			</Paper>
		</>
	);
};

export default Progress;
